import { ApiType } from "@gymflow/common";
import { zonedTimeToUtc } from "@gymflow/helpers";
import { useMutation } from "@tanstack/react-query";

export const useMutationSendSMSToMembersFilter = ({
  api,
  tz,
}: {
  api: ApiType;
  tz: string;
}) => {
  return useMutation({
    mutationFn: async (
      payload: Parameters<ApiType["smsApi"]["sendSMSToMembersFilter"]>[0],
    ) => {
      const parsedOpts = { ...payload };
      if (payload?.createdFrom) {
        parsedOpts.createdFrom = zonedTimeToUtc(payload.createdFrom, tz);
      }
      if (payload?.createdTo) {
        parsedOpts.createdTo = zonedTimeToUtc(payload.createdTo, tz);
      }
      if (payload?.membershipStartFrom) {
        parsedOpts.membershipStartFrom = zonedTimeToUtc(
          payload.membershipStartFrom,
          tz,
        );
      }
      if (payload?.membershipStartTo) {
        parsedOpts.membershipStartTo = zonedTimeToUtc(
          payload.membershipStartTo,
          tz,
        );
      }
      if (payload?.membershipCancellationFrom) {
        parsedOpts.membershipCancellationFrom = zonedTimeToUtc(
          payload.membershipCancellationFrom,
          tz,
        );
      }
      if (payload?.membershipCancellationTo) {
        parsedOpts.membershipCancellationTo = zonedTimeToUtc(
          payload.membershipCancellationTo,
          tz,
        );
      }
      if (payload?.membershipExpireFrom) {
        parsedOpts.membershipExpireFrom = zonedTimeToUtc(
          payload.membershipExpireFrom,
          tz,
        );
      }
      if (payload?.membershipExpireTo) {
        parsedOpts.membershipExpireTo = zonedTimeToUtc(
          payload.membershipExpireTo,
          tz,
        );
      }

      return (await api.smsApi.sendSMSToMembersFilter(parsedOpts)).data;
    },
  });
};
